import React,{useState,useEffect} from 'react'
import Check from '../../components/Check'
import Upload from '../../components/Upload'
import style from './Home.module.css';
import Activity from '../../components/Activity';

const UserManagement =()=> {
  const [selectedOption ,setSelectedOption] = useState('check')//'check' | 'upload' | 'activity'

  return (
    <div className={style.maindiv}>
        <div>
            <h1>IVR User Portal</h1>
        </div>
        <div className={style.togglediv}>
            <button onClick={() => setSelectedOption('check')} className={`${style.toggleBtn} ${selectedOption=="check"?style.activeBtn:''}`}>Check User</button>

            <button onClick={() => setSelectedOption('upload')} className={`${style.toggleBtn} ${selectedOption=="upload"?style.activeBtn:''}`}>Upload User To DB</button>

            {/* <button onClick={() => setSelectedOption('activity')} className={`${style.toggleBtn} ${selectedOption=="activity"?style.activeBtn:''}`}>Check Users Activities</button> */}
        </div>
        {
            selectedOption=="check" && <Check/>
        }
        {
            selectedOption=="upload" && <Upload/>
        }
        {/* {
            selectedOption=="activity" && <Activity/>
        } */}
    </div>
  )
}

export default UserManagement